import { ReactComponent as PlaceholderSvg } from '../../assets/icons/placeholder.svg';

export const PlaceholderIcon: SvgIcon = (props) => {
    return <PlaceholderSvg {...props} />;
};
